import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { PostDGOrgConfigV2 } from "../../api/api";

type DGOrgConfigResult = {
  status: string;
  notification?: boolean;
  msg?: string;
};

type DGOrgConfig = {
  siteName: string;
  dgname: string;
  config: object;
};

export const usePostDGConfig = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      siteName,
      dgname,
      config,
      token,
    }: DGOrgConfig & {
      token: string;
    }): Promise<DGOrgConfigResult> =>
      PostDGOrgConfigV2(token, {
        siteName: siteName,
        dgname: dgname,
        config,
      }),

    onSuccess: (data) => {},

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      { siteName, dgname, config }: DGOrgConfig,
      options?: {
        onSuccess?: (data: DGOrgConfigResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();

      mutation.mutate(
        {
          config,
          dgname,
          siteName,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
